import React from 'react';

export default function LoadingSpinner({ message }) {
  return (
    <div className="spinner-container">
      <div className="result-container">
        <div className="spinner" aria-hidden="true" />
        <p
          style={{ marginLeft: '10px' }}
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          {message}
        </p>
      </div>
      <p aria-live="polite" aria-atomic="true">This may take a few minutes...</p>
    </div>
  );
}
